import React from "react";
import {
  StyledButton,
  StyledButton1,
  StyledButton2,
  StyledButton3,
} from "../components/LoginStyles";
import {
  SaveButton,
  ChooseFileButton,
  FileNameButton,
} from "../components/formStyles";
import { CircleLoader } from "react-spinners";

const CustomButton = ({
  text,
  size,
  onClick,
  variant = "contained",
  color,
  className,
  type = "button",
  component = "button",
  fontSize = 14,
  fontWeight = "bold",
  disabled = false,

  width,
  buttonStyle = "style1",
  children,
  loading = false,
  loadingSize = 20,
  loaderStyle = {},
}) => {
  const ButtonComponent =
    buttonStyle === "style1"
      ? StyledButton1
      : buttonStyle === "style2"
      ? StyledButton2
      : buttonStyle === "style3"
      ? StyledButton3
      : buttonStyle === "saveButton"
      ? SaveButton
      : buttonStyle === "chooseFileButton"
      ? ChooseFileButton
      : buttonStyle === "fileNameButton"
      ? FileNameButton
      : StyledButton;

  return (
    <ButtonComponent
      variant={variant}
      size={size}
      disabled={disabled}
      onClick={onClick}
      color={color}
      type={type}
      className={className}
      component={component}
      disableRipple
      sx={{
        fontSize: `${fontSize}px`,
        fontWeight: fontWeight,
        width: width ? `${width}px` : "auto",
      }}
    >
      {loading ? (
        <CircleLoader size={loadingSize} sx={loaderStyle} />
      ) : (
        children || text
      )}
    </ButtonComponent>
  );
};

export default CustomButton;
